import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

export class ReaderListConsentGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {readerListConsent: props.initialValue ?? null};
  }

  setReaderListConsent = (hasConsent) => {
    this.setState({ readerListConsent: hasConsent }, () => {
      this.submit();
    });
  }

  submit = () => {
    const { readerListConsent } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({ readerListConsent })
    }
  }


  // render
  render() {
    const { t, updating } = this.props;
    const { readerListConsent } = this.state;
    return (
      <React.Fragment>
        <h2>{t('ReaderListConsentHeader')}</h2>
        <p>{t('ReaderListConsentInfo')}</p>
        <div role='group' aria-label={t('ReaderListConsentHeader')}
          style={{display: 'flex', gap: 8, justifyContent: 'center'}}>
          <Button
            variant={readerListConsent === true ? 'primary' : 'secondary'}
            aria-pressed={readerListConsent === true}
            disabled={updating}
            onClick={() => this.setReaderListConsent(true)}
          >{t('Yes')}</Button>
          <Button
            variant={readerListConsent === false ? 'primary' : 'secondary'}
            aria-pressed={readerListConsent === false}
            disabled={updating}
            onClick={() => this.setReaderListConsent(false)}
          >{t('No')}</Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(ReaderListConsentGetter)
